import { useCallback } from 'react';
import { validateTime } from '@elfsight/widget-utils';
import { parse } from 'fast-time-input';
import type { DropdownOption } from '../../_components/text-dropdown/text-dropdown';
import { isValidTimeInput } from '../utils';

export function useFindNearestOption(timeOptions: DropdownOption[]) {
  return useCallback(
    (inputTime: string): DropdownOption | undefined => {
      if (!inputTime) {
        return;
      }

      if (!isValidTimeInput(inputTime)) {
        return;
      }

      const parsed24 = parse(inputTime, '24hr');
      if (!parsed24 || !validateTime(parsed24)) {
        return;
      }

      const [hours, minutes] = parsed24.split(':').map(Number);
      const inputMinutes = hours * 60 + minutes;

      let nearestOption = timeOptions[0];
      let minDiff = Infinity;

      for (const option of timeOptions) {
        const [optHours, optMinutes] = option.value.split(':').map(Number);
        const optionMinutes = optHours * 60 + optMinutes;
        const diff = Math.abs(optionMinutes - inputMinutes);

        if (diff < minDiff) {
          minDiff = diff;
          nearestOption = option;
        }
      }

      return nearestOption;
    },
    [timeOptions]
  );
}
